import { Input, ModalFullscreen, ArticleHeading4, IconClose16 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './GeoSuggestModal.css';
import { TResultSuggestion } from '../../../../types/suggest';
import { IGeoSuggestProps } from '../../types';
import { LocationButton } from '../LocationButton';

interface IGeoSuggestModalProps extends IGeoSuggestProps {
  isOpen: boolean;
  onClose(): void;
}

export const GeoSuggestModal: React.FC<IGeoSuggestModalProps> = ({
  isOpen,
  onClose,
  onValueChange,
  onItemSelect,
  suggestions,
  onGetGeolocation,
  ...props
}) => {
  const inputRef = React.useRef<HTMLInputElement | null>(null);

  React.useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);

  const handleOnChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>, value: string) => {
      onValueChange(value);
    },
    [onValueChange],
  );

  const handleItemSelect = (item: TResultSuggestion) => {
    onItemSelect(item);
    onClose();
  };

  const handleGetGeolocation = React.useCallback(async () => {
    const locationName = await onGetGeolocation();
    onValueChange(locationName);
  }, [onValueChange, onGetGeolocation]);

  return (
    <ModalFullscreen open={isOpen} onClose={onClose} theme="white">
      <div className={styles['content']}>
        <div className={styles['header']}>
          <div className={styles['header-title-row']}>
            <ArticleHeading4>Укажите адрес</ArticleHeading4>
            <button type="button" title="Закрыть" className={styles['close-button']} onClick={onClose}>
              <IconClose16 />
            </button>
          </div>
          <Input
            {...props}
            inputRef={inputRef}
            onChange={handleOnChange}
            rightAdornment={<LocationButton onClick={handleGetGeolocation} />}
          />
        </div>
        <div className={styles['body']}>
          {suggestions && (
            <ul className={styles['suggestions']}>
              {suggestions.map((item, index) => (
                <li key={`suggestion_${index}`} className={styles['suggestion-item']}>
                  <button type="button" className={styles['suggestion-button']} onClick={() => handleItemSelect(item)}>
                    {item.displayName}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </ModalFullscreen>
  );
};
